import { type Member } from '@/features/iam/members/Member'

const roleLabels: Record<string, string> = {
  Provider: 'Pro',
  'Internal Taxfyle Team': 'Admin',
  'Relationship Manager': 'RM',
  'Firm Admin': 'Partner',
  'Firm Ally': 'Ally',
  Advisor: 'Advisor',
}

/**
 * The short label of the member's first role that has one, shown next to
 * the member's name on notes and progression history.
 */
export function memberRoleLabel(member: Member): string | undefined {
  return member.roles.map((r) => roleLabels[r.name.trim()]).find(Boolean)
}
